export function sayHello(name: string) {
  return `Hello, ${name}!`;
}
